import {keyToCoords} from "./keyToCoords";
import {coordsToKey} from "./coordsToKey";

export const getHexKeysInRange = (hexKey, distance) => {
  const [q, r] = keyToCoords(hexKey);
  const result = [];

  for (let dq = -distance; dq <= distance; dq++) {
    for (let dr = Math.max(-distance, -dq - distance); dr <= Math.min(distance, -dq + distance); dr++) {
      result.push(coordsToKey(q + dq, r + dr));
    }
  }

  return result;
};
